export const en = {
  'timesheets.title': 'Timesheets',
  'timesheets.description': 'Hours worked by the people paid by the hour. Approved hours go into the payroll for their month.',
  'timesheets.tab': 'Hours',
  'timesheets.myHint': 'Record the hours you worked. A manager approves them before they are paid.',
  'timesheets.approvedHours': 'Approved',
  'timesheets.pendingHours': 'Waiting for approval',
  'timesheets.hours': '{hours} h',
  'timesheets.locked': 'This month’s payroll is approved, so its hours no longer change.',
  'timesheets.notHourly': 'Not paid by the hour this month: these hours are kept, but payroll does not pay them.',
  'timesheets.add': 'Add hours',
  'timesheets.day': 'Day',
  'timesheets.mode': 'Record as',
  'timesheets.mode.range': 'From – to',
  'timesheets.mode.duration': 'Duration',
  'timesheets.start': 'Start',
  'timesheets.end': 'End',
  'timesheets.overnight': 'An end before the start is a shift that ran past midnight.',
  'timesheets.durationHours': 'Hours',
  'timesheets.added': 'Hours added',
  'timesheets.deleted': 'Hours removed',
  'timesheets.approveAll': 'Approve all waiting',
  'timesheets.approvedCount.one': '{count} entry approved',
  'timesheets.approvedCount.other': '{count} entries approved',
  'timesheets.empty': 'No hours recorded this month.',
  'timesheets.nobody': 'Nobody is paid by the hour or has hours recorded this month.',
  'timesheets.hourly': 'Paid by the hour',
  'timesheets.open': 'Open',
  'timesheets.of': 'Hours: {name}',
  'timesheets.waiting': 'Waiting',
  'timesheets.remove': 'Remove',
  'timesheets.payroll.fromTimesheet': 'from the timesheet',
  'timesheets.payroll.typed': 'typed in',
  'timesheets.payroll.typedHint': 'Typing hours stops this line taking them from the timesheet.',
  'timesheets.payroll.useTimesheet': 'Use the timesheet hours',
  'timesheets.payroll.usingTimesheet': 'The line takes its hours from the timesheet again',
  'timesheets.tab.today': 'Today',
  'timesheets.tab.month': 'Month',
  'timesheets.fromClock': 'Clock',
  'timesheets.inProgress': 'In progress',
  'timesheets.needsEnd': 'Needs an end',
  'timesheets.closedAtShiftEnd': 'Closed at the planned end of the shift',
  'timesheets.edit': 'Edit hours',
  'timesheets.saved': 'Hours updated',
  'timesheets.clockRecorded': 'The clock recorded {from} to {to}.',
  'timesheets.clockRecordedOpen': 'The clock recorded a clock-in at {from}.',
  'timesheets.correctionHint': 'Your correction sets the hours that are paid. The clock’s own record stays as it was.',
  'clock.title': 'Time clock',
  'clock.in': 'Clock in',
  'clock.out': 'Clock out',
  'clock.state.in': 'In since {time}',
  'clock.state.out': 'Not clocked in',
  'clock.shift': 'Shift {from}–{to}',
  'clock.offSite': 'You can only clock in and out from the gym’s network. Connect to the gym’s Wi-Fi and try again.',
  'clock.clockedIn': 'Clocked in at {time}',
  'clock.clockedOut': 'Clocked out at {time}',
  'clock.closedAtShiftEnd': 'That clock-in was left open too long, so it was closed at the planned end of your shift.',
  'clock.flagged': 'That clock-in was left open too long. A manager will give it an end.',
  'clockBoard.inNow': 'In now',
  'clockBoard.inNow.empty': 'Nobody is clocked in right now.',
  'clockBoard.late': 'Late',
  'clockBoard.late.empty': 'Nobody clocked in late today.',
  'clockBoard.lateBy': '+{minutes} min',
  'clockBoard.missing': 'Not clocked in',
  'clockBoard.missing.empty': 'Everyone whose shift has started has clocked in.',
  'clockBoard.needsEnd.empty': 'No clock-in is waiting for an end.',
  'clockBoard.noBranch': 'No branch',
  'clockBoard.in': 'In {time}',
  'clockBoard.out': 'Out {time}',
  'clockBoard.setEnd': 'Set the end',
  'clockBoard.endTitle': 'End of the entry: {name}',
  'clockBoard.endHint': 'Clocked in {day} at {time}. Give the time they stopped.',
  'clockBoard.endSaved': 'End saved',
  'clockBoard.extended': 'Extended',
  'clockBoard.extended.empty': 'Nobody has extra working time right now.',
  'clockBoard.extendedUntil': 'Extended until {time}',
  'clockBoard.extend.open': 'Extend working time',
  'clockBoard.extend.title': 'Extend working time',
  'clockBoard.extend.description': 'Keeps the person on duty for longer. The time is added after the end of their current duty, or from now when they are off duty, and never reaches more than 6 hours from now.',
  'clockBoard.extend.person': 'Person',
  'clockBoard.extend.personPlaceholder': 'Choose a person',
  'clockBoard.extend.minutes': 'Extra time',
  'clockBoard.extend.min': '{minutes} min',
  'clockBoard.extend.hours': '{hours} h',
  'clockBoard.extend.hoursMin': '{hours} h {minutes} min',
  'clockBoard.extend.reason': 'Reason',
  'clockBoard.extend.reasonHint': 'Kept with the extension.',
  'clockBoard.extend.save': 'Extend',
  'clockBoard.extend.done': 'Extended until {time}',
};

export const ka: Record<keyof typeof en, string> = {
  'timesheets.title': 'სამუშაო საათები',
  'timesheets.description': 'საათობრივი ანაზღაურების მქონე თანამშრომლების ნამუშევარი საათები. დამტკიცებული საათები შესაბამისი თვის ხელფასში შედის.',
  'timesheets.tab': 'საათები',
  'timesheets.myHint': 'ჩაწერეთ ნამუშევარი საათები. ანაზღაურებამდე მათ ხელმძღვანელი ამტკიცებს.',
  'timesheets.approvedHours': 'დამტკიცებული',
  'timesheets.pendingHours': 'ელოდება დამტკიცებას',
  'timesheets.hours': '{hours} სთ',
  'timesheets.locked': 'ამ თვის ხელფასი დამტკიცებულია, ამიტომ საათები აღარ იცვლება.',
  'timesheets.notHourly': 'ამ თვეში საათობრივი ანაზღაურება არ აქვს: საათები ინახება, მაგრამ ხელფასში არ ანაზღაურდება.',
  'timesheets.add': 'საათების დამატება',
  'timesheets.day': 'დღე',
  'timesheets.mode': 'ჩაწერის ფორმა',
  'timesheets.mode.range': 'დან – მდე',
  'timesheets.mode.duration': 'ხანგრძლივობა',
  'timesheets.start': 'დასაწყისი',
  'timesheets.end': 'დასასრული',
  'timesheets.overnight': 'თუ დასასრული დასაწყისზე ადრეა, ცვლა შუაღამის შემდეგ გაგრძელდა.',
  'timesheets.durationHours': 'საათები',
  'timesheets.added': 'საათები დაემატა',
  'timesheets.deleted': 'საათები წაიშალა',
  'timesheets.approveAll': 'ყველა მოლოდინში მყოფის დამტკიცება',
  'timesheets.approvedCount.one': 'დამტკიცდა {count} ჩანაწერი',
  'timesheets.approvedCount.other': 'დამტკიცდა {count} ჩანაწერი',
  'timesheets.empty': 'ამ თვეში საათები არ არის ჩაწერილი.',
  'timesheets.nobody': 'ამ თვეში არავის აქვს საათობრივი ანაზღაურება ან ჩაწერილი საათები.',
  'timesheets.hourly': 'საათობრივი ანაზღაურება',
  'timesheets.open': 'გახსნა',
  'timesheets.of': 'საათები: {name}',
  'timesheets.waiting': 'მოლოდინში',
  'timesheets.remove': 'წაშლა',
  'timesheets.payroll.fromTimesheet': 'სამუშაო საათებიდან',
  'timesheets.payroll.typed': 'ხელით შეყვანილი',
  'timesheets.payroll.typedHint': 'საათების ხელით შეყვანის შემდეგ ეს ხაზი მათ სამუშაო საათების აღრიცხვიდან აღარ იღებს.',
  'timesheets.payroll.useTimesheet': 'სამუშაო საათების გამოყენება',
  'timesheets.payroll.usingTimesheet': 'ხაზი საათებს ისევ სამუშაო საათების აღრიცხვიდან იღებს',
  'timesheets.tab.today': 'დღეს',
  'timesheets.tab.month': 'თვე',
  'timesheets.fromClock': 'დროის აღრიცხვა',
  'timesheets.inProgress': 'მიმდინარეობს',
  'timesheets.needsEnd': 'საჭიროა დასასრული',
  'timesheets.closedAtShiftEnd': 'დაიხურა ცვლის დაგეგმილ დასრულებაზე',
  'timesheets.edit': 'საათების შეცვლა',
  'timesheets.saved': 'საათები განახლდა',
  'timesheets.clockRecorded': 'საათმა აღრიცხა: {from}–{to}.',
  'timesheets.clockRecordedOpen': 'საათმა მოსვლა აღრიცხა {from}-ზე.',
  'timesheets.correctionHint': 'თქვენი შესწორება ანაზღაურებად საათებს განსაზღვრავს. საათის საკუთარი ჩანაწერი უცვლელი რჩება.',
  'clock.title': 'სამუშაო დროის აღრიცხვა',
  'clock.in': 'მოსვლის აღრიცხვა',
  'clock.out': 'წასვლის აღრიცხვა',
  'clock.state.in': 'სამუშაოზე ხართ {time}-დან',
  'clock.state.out': 'მოსვლა აღრიცხული არ არის',
  'clock.shift': 'ცვლა {from}–{to}',
  'clock.offSite': 'მოსვლა და წასვლა მხოლოდ დარბაზის ქსელიდან აღირიცხება. დაუკავშირდით დარბაზის Wi-Fi-ს და სცადეთ ხელახლა.',
  'clock.clockedIn': 'მოსვლა აღირიცხა {time}-ზე',
  'clock.clockedOut': 'წასვლა აღირიცხა {time}-ზე',
  'clock.closedAtShiftEnd': 'ეს მოსვლა ძალიან დიდხანს იყო ღია, ამიტომ ჩანაწერი ცვლის დაგეგმილ დასრულებაზე დაიხურა.',
  'clock.flagged': 'ეს მოსვლა ძალიან დიდხანს იყო ღია. ჩანაწერს დასასრულს ხელმძღვანელი მიუთითებს.',
  'clockBoard.inNow': 'ახლა სამუშაოზე არიან',
  'clockBoard.inNow.empty': 'ამჟამად არავის აქვს მოსვლა აღრიცხული.',
  'clockBoard.late': 'დაგვიანებულები',
  'clockBoard.late.empty': 'დღეს არავის დაუგვიანია.',
  'clockBoard.lateBy': '+{minutes} წთ',
  'clockBoard.missing': 'მოსვლა აღრიცხული არ აქვთ',
  'clockBoard.missing.empty': 'ყველას, ვისაც ცვლა დაწყებული აქვს, მოსვლა აღრიცხული აქვს.',
  'clockBoard.needsEnd.empty': 'დასასრულის მომლოდინე ჩანაწერი არ არის.',
  'clockBoard.noBranch': 'ფილიალის გარეშე',
  'clockBoard.in': 'მოსვლა {time}',
  'clockBoard.out': 'წასვლა {time}',
  'clockBoard.setEnd': 'დასასრულის მითითება',
  'clockBoard.endTitle': 'ჩანაწერის დასასრული: {name}',
  'clockBoard.endHint': 'მოსვლა აღირიცხა {day}, {time}-ზე. მიუთითეთ, როდის დაასრულეს.',
  'clockBoard.endSaved': 'დასასრული შენახულია',
  'clockBoard.extended': 'გაგრძელებული დრო',
  'clockBoard.extended.empty': 'ამჟამად არავის აქვს გაგრძელებული სამუშაო დრო.',
  'clockBoard.extendedUntil': 'გაგრძელებულია {time}-მდე',
  'clockBoard.extend.open': 'სამუშაო დროის გაგრძელება',
  'clockBoard.extend.title': 'სამუშაო დროის გაგრძელება',
  'clockBoard.extend.description': 'თანამშრომელი უფრო დიდხანს რჩება მორიგეობაზე. დრო ემატება მიმდინარე მორიგეობის დასრულების შემდეგ, ხოლო თუ ცვლის გარეთაა, ახლიდან; ახლიდან 6 საათზე მეტით არასოდეს გრძელდება.',
  'clockBoard.extend.person': 'თანამშრომელი',
  'clockBoard.extend.personPlaceholder': 'აირჩიეთ თანამშრომელი',
  'clockBoard.extend.minutes': 'დამატებითი დრო',
  'clockBoard.extend.min': '{minutes} წთ',
  'clockBoard.extend.hours': '{hours} სთ',
  'clockBoard.extend.hoursMin': '{hours} სთ {minutes} წთ',
  'clockBoard.extend.reason': 'მიზეზი',
  'clockBoard.extend.reasonHint': 'ინახება გაგრძელებასთან ერთად.',
  'clockBoard.extend.save': 'გაგრძელება',
  'clockBoard.extend.done': 'დრო გაგრძელდა {time}-მდე',
};
